import React from 'react';
import { Button } from 'react-admin';
import { Link } from 'react-router-dom';
import ChatBubbleIcon from '@material-ui/icons/AlarmOn';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    button: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  }));

const RunButton = ({ record }) => {
    const classes = useStyles();
  
    return (
      record && record.manualStart ?
      <Button className={classes.button} 
            variant="contained"
            component={Link}
            to={{
                pathname: '/storage/create',
                state: { record: { name: record.name } }
            }}>
        <ChatBubbleIcon />
      </Button>
      : null
    );
};

export default RunButton;